import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import { LoadingButton } from "@mui/lab";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const COLORS = {
  gray: {
    main: "#9e9e9e",
  },
  primary: "#233F91",
  second: "#797979",
  text: {
    primary: "#233F91", // Text color from the design
    error: "#E53E3E", // Error color for the title
  },
};

type Props = {
  title: string;
  subtitle?: string;
  cancelText: string;
  red?: string;
  black?: string;
  titleColor?: string;
  warning?: string;
  isLoading: boolean;
  confirmText: string;
  onCancel: () => void;
  onConfirm: () => void;
  icon?: React.ReactNode;
  isConfirmModal: boolean;
};

const ConfirmModal = (props: Props) => {
  const {
    icon,
    title,
    onCancel,
    red,
    black,
    titleColor,
    warning,
    subtitle,
    onConfirm,
    isLoading,
    cancelText,
    confirmText,
    isConfirmModal,
  } = props || {};

  const onClose = () => !isLoading && onCancel();

  return (
    <React.Fragment>
      <Modal
        onClose={onClose}
        open={isConfirmModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box p={2} display={"flex"} justifyContent={"flex-end"}>
            <ClearOutlinedIcon
              sx={{ color: COLORS.gray.main, cursor: "pointer" }}
              onClick={onClose}
            />
          </Box>
          <Box px={5} pt={2} pb={5} textAlign="center">
            {icon && (
              <Box display={"flex"} justifyContent={"center"}>
                {icon}
              </Box>
            )}
            <Box
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              gap={1}
            >
              {red === "red" && (
                <ErrorOutlineIcon
                  sx={{ color: COLORS.text.error, fontSize: 40 }}
                />
              )}
              <Typography
                fontSize={18}
                fontWeight={600}
                sx={{ color: COLORS.text.error }}
              >
                {warning}
              </Typography>
            </Box>

            <Typography
              my={1}
              fontSize={{ xs: 14, md: 17 }}
              fontWeight={{ xs: 600, md: 400 }}
              // color={`${red === "red" ? COLORS.text.error : "#233F91"}`}
              color={{ xs: "#020303", md: titleColor }}
            >
              {title}
            </Typography>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              width="100%"
            >
              <Typography
                my={1}
                width={264}
                // lineHeight={"17.07px"}
                fontSize={14}
                fontWeight={500}
                color={"#636F65"}
                textAlign="center"
              >
                {subtitle}
              </Typography>
            </Box>
            <Box
              display="flex"
              justifyContent={"center"}
              gap={2}
              pt={{ xs: 2, md: 1 }}
            >
              <Button
                fullWidth
                onClick={onClose}
                variant="outlined"
                sx={{
                  width: "114px",
                  height: "48px",
                  color: "#fff",
                  borderRadius: "15px",
                  mt: 2,
                  py: 1,
                  backgroundColor: COLORS.second,
                  border: `1px solid ${COLORS.second}`,
                  "&:hover": { backgroundColor: COLORS.second },
                }}
                disabled={isLoading}
              >
                {cancelText}
              </Button>
              <LoadingButton
                fullWidth
                onClick={onConfirm}
                variant="contained"
                loading={isLoading}
                disabled={isLoading}
                sx={{
                  width: "114px",
                  height: "48px",
                  color: "#fff",
                  borderRadius: "15px",
                  mt: 2,
                  py: 1,
                  backgroundColor: COLORS.primary,
                }}
              >
                {confirmText}
              </LoadingButton>
            </Box>
          </Box>
        </Box>
      </Modal>
    </React.Fragment>
  );
};

export default ConfirmModal;

const style = {
  width: { xs: 300, md: 626 },
  top: "50%",
  left: "50%",
  boxShadow: 0,
  border: "none",
  borderRadius: "10px",
  bgcolor: "background.paper",
  position: "absolute" as "absolute",
  transform: "translate(-50%, -50%)",
};
